<template lang='pug'>
	.container-fluid.p-0.push-wrapper
		.container
			.row
				.col
					.row
						.col-12.my-header.font-weight-bold
							| Сотрудники

		.container.mt-5
			.row
				.col
					button.styled(@click='$modal.show("new_user")') Добавить сотрудника
			.row.mt-4
			.col-sm(v-if='employee_loading')
				.loader_holder(style="margin: 0 auto; width: 200px;")
					object(type="image/svg+xml" data="/assets/loaders/infinity.svg")
			.white_block(v-for="e of employee").employee
				.row
					.col
						.name {{e.name}}
						.stock Привязан к 
							b {{e.store_name}}
					.col.text-right
						button.styled.red(@click="removeUser(e)" :disabled="e.removing")
							<i class="far fa-trash-alt"></i>

		modal.new_user(name="new_user" height="auto" :adaptive="true") 
			.close(@click='$modal.hide("new_user")')
				<i class="fal fa-times"></i>
			.container
				.row
					.col
						h2 Создание нового пользователя
						.content
							.inputModule
								input-module(type="text" title="Имя пользователя" v-model="new_user_name") 
							.inputModule
								input-module(type="select" title="Привязка к складу" v-model="new_store_id" :values="warehouses" valueKey="id" valueName="name" )
							.inputModule
								input-module(type="select" title="Тип пользователя" v-model="new_user_type" :values="user_types" valueKey="id" valueName="name") 
							br
							button.styled.createLink(:disabled="new_user_name == '' || loading_adding" @click='createUser') Создать пользователя
							br

</template>
<script>
import moment from "moment";
import apiDriver from '../../apiDriver';
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
	components: {},

	data() {
		return {
			employee: [],
			employee_loading: true,
			warehouses: [],
			warehouse_loading: true,
			new_user_name: '',
			new_store_id: '',
			new_user_type: '',
			user_types: [{id: 1, name: 'Сотрудник бара'}, {id: 20, name: 'Раздатчик кодов'}],
			loading_adding: false
		};
	},

	computed: {},

	async mounted() {
		await this.loadWarehouses();
		await this.loadWarehouses();
		await this.loadEmployee();
		this.new_store_id = this.warehouses[0].id;
		this.new_user_type = this.user_types[0].id;
	},

	methods: {
		async loadWarehouses(){
			let warehouses = (await apiDriver.services.api.get('inventory', 'store/list')).data.list;
			this.warehouses = warehouses;
			this.warehouse_loading = false;
		},
		async loadEmployee(){
			let employee = (await apiDriver.services.api.get('inventory', 'employee/list')).data.list;
			console.log("employee:", employee);
			this.employee = employee;
			this.employee_loading = false;
			for(let e of this.employee) e = this.findOutEmployeeWarehouse(e);
		},
		async createUser(){
			this.loading_adding = true;
			this.$toast.info('Создание пользователя...');
			let new_user = await apiDriver.services.api.post('inventory', 'employee/create', {name: this.new_user_name, store_id: this.new_store_id, type: this.new_user_type});
			if(!new_user){
				this.loading_adding = false;
				this.$toast.error('Ошибка создания пользователя...');
				return;
			}
			new_user = new_user.data.employee;
			this.loading_adding = false;
			this.new_user_name = "";
			this.$toast.success('Пользователь создан!');
			this.$modal.hide("new_user");
			new_user = this.findOutEmployeeWarehouse(new_user);
			this.employee.push(new_user);
			console.log("new_user", new_user);
		},
		async removeUser(user){
			swal({
				title: 'Вы уверены?',
				text: "Удаляем пользователя "+user.name+"?",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Да! Удаляй!',
				cancelButtonText: 'Нет, стоп...'
			}).then(async (result) => {
				if (result) {
					user.removing = true;
					let removed = await apiDriver.services.api.post('inventory', 'employee/remove', {id: user.id});
					if(!removed){
						this.$toast.error('Ошибка удаления пользователя...');
						user.removing = false;
						return;
					}
					this.employee = this.employee.filter(x=>x.id!=user.id);
					this.$toast.success('Пользователь удален!');
				}
			});
		},
		findOutEmployeeWarehouse(user){
			let warehouse = this.warehouses.find(x=>x.id==user.store_id);
			if(warehouse){
				user.store_name = warehouse.name;
			}else{
				user.store_name = "-склада больше не существует-";
			}
			return user;
		}
	}
};
</script>
<style scoped lang="stylus">
	div{
		cursor: default;
	}
	.my-header{
		font-size: 26pt;
	}
	.header-pre-push{
		font-size: 1.5rem;
	}
	.header-push{
		font-size: 1.5rem; color: black;
	}

	button.styled {
		margin-bottom: 5px;
		border: 1px solid #6c68cb;
		padding: 10px 15px;
		border-radius: 4px;
		color: #464384;
		cursor: pointer;
		background: white;
		min-height 45px;
		min-width: 45px;
		&:hover {
			background: #6c68cb;
			color: white;
		}
		
		&.red{
			padding: 10px 6px;
			color: #F44336;
			border-color: #F44336;
			margin-left: 5px;
			&:hover{
				background: #F44336;
				color: white;
			}
		}

		&[disabled] {
			border-color: #ddd;
			color: #ddd;
			cursor: default;
			background: white;
		}
		&:last-child {
			margin-bottom: 0;
		}
	}

	.employee{
		.name{
			font-size: 12pt;
		}
		.stock{
			font-size: 10pt;
		}
	}

</style>
